import { ref, onMounted, onUnmounted } from 'vue'

export function useDropdownBehavior() {
    const show = ref(false)

    function toggle() {
        show.value = !show.value
    }

    function close() {
        show.value = false
    }

    function handleOutsideClick(evt: MouseEvent) {
        const target = evt.target as HTMLElement
        if (!target.closest('.dropdown-praeparate')) {
            close()
        }
    }

    function handleEscapeKey(evt: KeyboardEvent) {
        if (evt.key === 'Escape') {
            close()
        }
    }

    onMounted(() => {
        window.addEventListener('click', handleOutsideClick)
        window.addEventListener('keydown', handleEscapeKey)
    })

    onUnmounted(() => {
        window.removeEventListener('click', handleOutsideClick)
        window.removeEventListener('keydown', handleEscapeKey)
    })

    return {
        show,
        toggle,
        close
    }
}